import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/travel/vip/init', method: 'GET', params }, { interceptResultCode: false });
};

// 账号注销
export const onLogoutApi = (data) => {
  return axios({ url: '/game/my/disable', method: 'POST', data }, { interceptResultCode: false });
};

// vip奖励
export const onVipStoreApi = (data) => {
  return axios({ url: '/travel/vip/store', method: 'POST', data }, { interceptResultCode: false });
};

// 助力初始化
export const onHelpGetInitDataAPI = (params) => {
  return axios({ url: '/travel/vip/help', method: 'GET', params }, { interceptResultCode: false });
};

// 激活分享码
export const onCodeUpdateAPI = (data) => {
  return axios({ url: '/travel/vip/update', method: 'POST', data }, { interceptResultCode: false });
};

// 好友领取分享的奖励
export const onHelpFriendRewardsAPI = (data) => {
  return axios({ url: '/travel/vip/help', method: 'POST', data }, { interceptResultCode: false });
};

// 下载地址
export const onDownloadApi = (params) => {
  return axios({ url: '/get_url?game_id=35', method: 'GET', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/travel/invitation/api.js